/* eslint-disable */

<template>
  <div
    v-if="showPopup"
    :class="['pwa-installer', {
      'pwa-installer--hidden': hidden,
    }]"
    :hidden="hidden"
    role="alert"
  >
    <z-text tag="p">
      Deseja instalar o nosso app?
    </z-text>

    <div class="pwa-installer__actions">
      <z-button
        class="test-class-refuse"
        aria-label="Não instalar o aplicativo"
        variant="secondary"
        size="small"
        @click="refuse"
      >
        <z-icon :icon="['far', 'times']" />
      </z-button>

      <z-button
        class="test-class-install"
        aria-label="Instalar o aplicativo"
        size="small"
        @click="install"
      >
        <z-icon :icon="['far', 'check']" />
      </z-button>
    </div>
  </div>
</template>

<script>
import { ZIcon, ZText } from '@quero/zilla-vue';

export default {
  name: 'PwaInstaller',
  components: {
    'z-icon': ZIcon,
    'z-text': ZText,
  },
  data() {
    return {
      hidden: true,
      hasPromptEvent: false,
      promptInstall: undefined,
    };
  },
  computed: {
    showPopup() {
      if (window) {
        const PWA_REFUSED = this.getWithExpiry('PWA_REFUSED');
        const cookieConsentPopup = document.querySelector('.cookie-consent');

        return !cookieConsentPopup && this.hasPromptEvent && !PWA_REFUSED;
      }

      return false;
    },
  },
  beforeMount() {
    this.$promptEvent?.then((event) => {
      this.promptInstall = event;
      this.hasPromptEvent = true;
      this.hidden = false;
    });
  },
  methods: {
    setWithExpiry(key, value, ttl) {
      const now = new Date();

      const item = {
        value,
        expiry: now.getTime() + ttl,
      };

      localStorage.setItem(key, JSON.stringify(item));
    },
    getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      if (!itemStr) return null;

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    },
    async install() {
      this.hidden = true;
      this.promptInstall.prompt();
    },
    refuse() {
      const weekInMilliseconds = 7 * 24 * 60 * 60 * 1000;
      this.setWithExpiry('PWA_REFUSED', true, weekInMilliseconds);
      this.hidden = true;
    },
  },
};
</script>

<style lang="scss">
.pwa-installer {
  align-items: center;
  animation: 0.8s slide-up-xs forwards;
  animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  background: var(--color-white);
  border: 2px solid var(--color-primary);
  border-radius: 6px;
  bottom: 8px;
  box-shadow: 0 16px 32px -16px rgba(19, 23, 26, .24);
  box-sizing: border-box;
  column-gap: 16px;
  display: flex;
  justify-content: space-between;
  left: 8px;
  padding: 8px 16px;
  position: fixed;
  right: 8px;
  transition: 2s transform;
  width: calc(100% - 16px);
  z-index: 999999;

  @media (min-width: $screen-md-min) {
    animation-name: slide-up-md;
    bottom: var(--unit-0800);
    left: 50%;
    max-width: 460px;
    right: unset;
  }
}

.pwa-installer--hidden {
  animation-name: slide-down-xs;

  @media (min-width: $screen-md-min) {
    animation-name: slide-down-md;
  }
}

.pwa-installer__actions {
  align-items: center;
  column-gap: 8px;
  display: flex;
}

@keyframes slide-up-xs {
  0% { transform: translateY(500px); }
  100% { transform: translateY(0); }
}

@keyframes slide-up-md {
  0% { transform: translate(-50%, 500px); }
  100% {
    transform: translate(-50%, 0);
  }
}

@keyframes slide-down-xs {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(500px);
  }
}

@keyframes slide-down-md {
  0% {
    transform: translate(-50%, 0);
  }
  100% {
    transform: translate(-50%, 500px);
  }
}
</style>
